
































import { Vue, Prop, Component } from "vue-property-decorator";
import TextField from "@/components/form/CustomPage/textField.vue";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import { User as IUser } from "@/api/models/user";

@Component({
  components: { TextField }
})
export default class AgentInformation extends Vue {
  @Prop() agent!: IAgent;
  @Prop() user?: IUser;
}
